import { useQuery } from '@tanstack/react-query';
import IPaginatedParams from '@models/paginated-params';
import { getNotifications } from '../services/notificationServices';

export const useGetNotifications = (
  paginatedParams: IPaginatedParams,
  userId: string,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: ['notifications', paginatedParams, userId],
    queryFn: () => getNotifications(paginatedParams, userId),
    enabled,
  });
};
